import { Instagram } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { INSTAGRAM, SITE } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

const spans = [
  "md:col-span-2 md:row-span-2",
  "",
  "",
  "md:col-span-2",
  "",
  "",
];

export const InstagramSection = () => {
  const { t } = useLang();
  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="py-24 md:py-36 bg-background"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <Reveal>
            <Eyebrow>{t.instagram.eyebrow}</Eyebrow>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-5">
              @tribebeachkos
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <a
              data-testid="instagram-follow"
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm uppercase tracking-luxe text-primary border-b border-primary pb-1 hover:text-accent hover:border-accent transition-colors"
            >
              <Instagram size={16} /> {t.common.followIg}
            </a>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 auto-rows-[160px] md:auto-rows-[220px]">
          {INSTAGRAM.map((src, i) => (
            <Reveal
              key={i}
              delay={i * 0.06}
              className={`overflow-hidden group ${spans[i] || ""}`}
            >
              <a
                data-testid={`instagram-post-${i}`}
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="block relative h-full w-full"
              >
                <img
                  src={src}
                  alt={`Tribe Beach Lounge Kos on Instagram — beach lounge moment ${i + 1}`}
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/30 transition-colors duration-300 flex items-center justify-center">
                  <Instagram
                    size={28}
                    className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
